export const NeedlReportSelectedSources = ({
  selectedCount,
}: NeedlReportSelectedSourcesProps) => {
  return (
    <div className='text-xs text-gray-700'>{`${selectedCount} source${
      selectedCount === 1 ? '' : 's'
    }`}</div>
  );
};

type NeedlReportSelectedSourcesProps = {
  selectedCount: number;
};
